import React, { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { yupResolver } from '@hookform/resolvers/yup';
import { ERROR_PAGE } from 'constants/IncorporationConstants';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import { InviteOfTermsSchema } from 'components/IncorporationOfTerms/IncorporationOfTermsSchema';
import Form from 'components/IncorporationOfTerms/Register/FormMolecules/Form';
import PasswordForm from 'components/IncorporationOfTerms/Register/FormMolecules/PasswordForm';
import NameForm from 'components/IncorporationOfTerms/Register/FormMolecules/NameForm';
import MobileForm from 'components/IncorporationOfTerms/Register/FormMolecules/MobileForm';
import ResidenceCntry from 'components/IncorporationOfTerms/Register/FormMolecules/ResidenceCntry';
import InviteIdForm from 'components/IncorporationOfTerms/Register/FormMolecules/InviteIdForm';
import Terms from 'components/IncorporationOfTerms/Terms/Terms';
import * as alertActions from 'redux/ducks/common/alertDucks';
import * as invitationActions from 'redux/ducks/Employee/InvitationDucks';

// [8.0] 03_초대링크를 통한 가입

export const InviteRegister = ({ langCd, onValidationChange }, ref) => {
  const dispatch = useDispatch();
  const { employeeVo, duplicateIdCheck, isOtpSuccess, linkInvtCd } = useSelector(state => state.invitation);
  const { residenceCntry, termsContents } = useSelector(state => state.terms);
  // 최초 submit 없이 onChange 로 값 체크
  useEffect(() => {
    if (!linkInvtCd || Object.keys(employeeVo).length === 0) {
      window.location.href = ERROR_PAGE;
    }
    // 회사 코드 없으면 에러 페이지로 넘김
  }, [employeeVo, linkInvtCd]);
  const inviteFormMethods = useForm({
    mode: 'onChange',
    resolver: yupResolver(InviteOfTermsSchema()),
  });
  const {
    formState: { isValid },
  } = inviteFormMethods;
  useEffect(() => {
    onValidationChange(isValid);
  }, [isValid, onValidationChange]);
  const inviteOnSubmit = values => {
    const pslInfoAgmts = [];
    termsContents.map(item => {
      pslInfoAgmts.push({
        trmsCd: item.trmsCd,
        trmsVerVal: item.trmsVerVal,
        agmtYn: values[`${item.trmsCd}`] ? 'Y' : 'N',
      });
    });

    const payload = {
      ...employeeVo,
      userId: values.userId,
      pwd: values.pwd,
      cpwd: values.pwdConfirm,
      snm: values.snm,
      gnm: values.gnm,
      fnm: values.fnm ? values.fnm : `${values.snm}${values.gnm}`,
      linkInvtCd,
      enFnm: values.fnm ? values.fnm : `${values.snm}${values.gnm}`,
      enGnm: values.gnm,
      enSnm: values.snm,
      locale: langCd,
      mphonNo: values.mphonNo !== values.nationTelCode ? values.mphonNo : '',
      emmtTypeCd: 'N',
      deptCd: 'TOP',
      authnum: values.otp,
      jobplAddrCntryCd: residenceCntry.value,
      pslInfoAgmts,
    };
    dispatch(invitationActions.createInviteEmp(payload));
  };

  const checkPersonalOption = value => {
    // ID 중복 검증 미진행시
    if (!duplicateIdCheck) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: [duplicateIdCheck],
        }),
      );
    }
    // OTP 미진행시
    if (!isOtpSuccess) {
      dispatch(
        alertActions.open({
          isDimed: true,
          message: [isOtpSuccess],
        }),
      );
    }

    inviteOnSubmit(value);
  };

  return (
    <>
      {linkInvtCd && (
        <Form formControl={inviteFormMethods} handleSubmit={checkPersonalOption} ref={ref}>
          <div className="form-section">
            <ul className="form-table">
              <FormTitle title="MB_T_INFORMATION" isRequired />
              <InviteIdForm />
              <PasswordForm disabled={!isOtpSuccess} />
              <NameForm disabled={!isOtpSuccess} />
              <MobileForm disabled={!isOtpSuccess} />
              <ResidenceCntry />
            </ul>
            <Terms />
          </div>
        </Form>
      )}
    </>
  );
};

InviteRegister.propTypes = { langCd: PropTypes.string, onValidationChange: PropTypes.func };
InviteRegister.defaultProps = { langCd: 'ko', onValidationChange: () => {} };

export default forwardRef(InviteRegister);
